import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { imageFragment } from 'bundles/ent-website/queries/common';

export const entWebsiteValuePropFragment = contentfulGql`#graphql
  ${imageFragment}

  fragment EntWebsiteValueProp on EntWebsiteValuePropModule {
    slug
    headline
    description
    valuePropCardsCollection {
      items {
        slug
        headline
        description
        icon {
          ...Image
        }
      }
    }
  }
`;

export const entWebsiteBlockValuePropQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteValuePropFragment}
  query entWebsiteBlockValueProp($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteValueProp
      }
    }
  }
`;
